import React, { useState, useEffect } from 'react';
import { Calendar, Badge, message, Tooltip } from 'antd';
import type { Dayjs } from 'dayjs';
import { getHolidays } from '../../ducks/actions';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';

const HolidayCalendar = ({ providerData }) => {
  const dispatch: any = useDispatch();

  const holidaysApi = useSelector((state: any) => state.calendar.holidaysData);
  const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null });

  const setMonthDateRange = (date) => {
    if(dayjs(date).isValid()){
      const startOfMonth = date.startOf('month');
      const endOfMonth = date.endOf('month');
      
      setDateRange({
        fromDate: startOfMonth.format('YYYY-MM-DD'),
        toDate: endOfMonth.format('YYYY-MM-DD'),
      });
    }
  };

  useEffect(() => {
    const currentMonth = dayjs();
    setMonthDateRange(currentMonth);
  }, []);


  const onPanelChange = (value) => {
    setMonthDateRange(dayjs(value));
  };

  useEffect(() => {
    if (providerData && dateRange?.fromDate && dateRange?.toDate) {
      const payload = {
        provider: providerData,
        range: [dateRange?.fromDate, dateRange?.toDate]
      }
      setTimeout(() => {
        dispatch(getHolidays(payload));
      }, 800);
    }
  }, [dateRange, providerData]);

  const dateCellRender = (value: Dayjs) => {
    const formattedDate = value?.format('YYYY-MM-DD');
    const holiday = holidaysApi?.length>0 ? holidaysApi?.find((holiday) => dayjs(holiday.date).format('YYYY-MM-DD') === formattedDate) : null;
    return (
      <td className="ant-picker-cell ant-picker-cell-in-view">
        <div className="ant-picker-cell-inner ant-picker-calendar-date">
          <div className="ant-picker-calendar-date-value">
            {holiday ? (
              <Tooltip title={holiday?.attributes?.description || "Holiday"} arrow={false}>
                <div className='highlighted-date-cell'>
                  {value.date()}
                </div>
              </Tooltip>
            ) : (
              value.date()
            )}
          </div>
          <div className="ant-picker-calendar-date-content"></div>
        </div>
      </td>
    );
  };


  const getStatusText = () => (
    <>
      {!holidaysApi?.length && providerData && dateRange?.fromDate && dateRange?.toDate && (
        <span className="no-holidays-text">
          <span style={{ color: "red" }}>No holidays to show</span>
        </span>
      )}
    </>
  );

  return (<>
    {getStatusText()}
    <Calendar fullscreen={false} onPanelChange={onPanelChange} fullCellRender={dateCellRender}  />
  </>);
};

export default HolidayCalendar;
